module.exports = __webpack_public_path__ + "public/images/prizes-bg.e073ac0f482d70d8c171039e0a469cdc.svg";